import {
  IndexerGrpcMitoStream,
  HistoricalStakingStreamCallback,
  StakingRewardByAccountStreamCallback
} from '@injectivelabs/sdk-ts'
import { MITO_API_ENDPOINT } from '@/app/utils/constant'
import { streamProvider } from '@/app/providers/StreamProvider'
import { StreamType } from '@/types'

export const mitoStream = new IndexerGrpcMitoStream(MITO_API_ENDPOINT)

export const streamStakingRewardByAccount = ({
  staker,
  callback,
  stakingContractAddress
}: {
  staker: string
  stakingContractAddress: string
  callback: StakingRewardByAccountStreamCallback
}) => {
  const streamFn = mitoStream.streamStakingRewardsByAccount.bind(mitoStream)
  const streamFnArgs = {
    callback,
    staker,
    stakingContractAddress
  }

  streamProvider.subscribe({
    fn: streamFn,
    args: streamFnArgs,
    key: StreamType.StakingRewardByAccount
  })
}

export const streamHistoricalStaking = ({
  staker,
  callback,
  stakingContractAddress
}: {
  staker: string
  stakingContractAddress: string
  callback: HistoricalStakingStreamCallback
}) => {
  const streamFn = mitoStream.streamHistoricalStaking.bind(mitoStream)
  const streamFnArgs = {
    callback,
    staker,
    stakingContractAddress
  }

  streamProvider.subscribe({
    fn: streamFn,
    args: streamFnArgs,
    key: StreamType.HistoricalStaking
  })
}
